export default __webpack_public_path__ + "static/media/black-clock.23f43068.svg";